import { useOutletContext } from 'react-router-dom';
import { ErrorPageLayout, PaperLayout } from '../../../../presentation';
import { QuotesEntityPageContainer } from '../quotes-entity.page.container';
import { GetQuoteQuery, QuoteType } from '@converge/graphql';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { QuoteInfoFormSection } from './form-sections';
import './quote.detail.overview.scss';

interface IProps {
  quoteDetails: GetQuoteQuery;
  quoteUuid: string;
}

export const QuotesDetailOverview = () => {
  const { quoteDetails } = useOutletContext<IProps>();
  if (!quoteDetails) {
    return (
      <ErrorPageLayout
        message="No Quote data found"
        messageId="entity.quotes.detail.page.notFound"
      />
    );
  }

  return <QuoteDetailOverviewInner data={quoteDetails} />;
};

export const QuoteDetailOverviewInner = ({ data }: { data: GetQuoteQuery }) => {
  const defaultValues = useMemo(() => mapToUIOverviewModel(data), [data]);
  const formMethods = useForm({
    defaultValues,
  });

  return (
    <QuotesEntityPageContainer title="Overview">
      <PaperLayout className="quote-detail-overview-layout">
        <FormProvider {...formMethods}>
          <div className="form-wrapper">
            <QuoteInfoFormSection isReadonly={true} />
          </div>
        </FormProvider>
      </PaperLayout>
    </QuotesEntityPageContainer>
  );
};
const mapToUIOverviewModel = ({ quote }: GetQuoteQuery) => {
  return {
    uuid: quote?.uuid as string,
    referenceId: quote?.referenceId || '',
    status: quote?.status || null,
    type: quote?.type || QuoteType.DefaultQuote,
    name: quote?.name || '',
    ratedPremium: quote?.ratedPremium || '',
    quotedPremium: quote?.quotedPremium || '',
    limit: quote?.limit || '',
    retention: quote?.retention || '',
    minimumPremium: quote?.minimumPremium || '',
    technicalPremium: quote?.technicalPremium || '',
    isObsolete: quote?.isObsolete || '',
    obsoleteAt: quote?.obsoleteAt || '',
    endorsementImpact: quote?.endorsementImpact || '',
    stcSelectedModifier: quote?.stcSelectedModifier || '',
    stcMinModifier: quote?.stcMinModifier || '',
    stcMaxModifier: quote?.stcMaxModifier || '',
    stcModifier: quote?.stcModifier || '',
    stcRatedModifier: quote?.stcRatedModifier || '',
    erMinFusionScoreModifier: quote?.erMinFusionScoreModifier || '',
    erMaxFusionScoreModifier: quote?.erMaxFusionScoreModifier || '',
    erRatedFusionScoreModifier: quote?.erRatedFusionScoreModifier || '',
    erSelectedFusionScoreModifier: quote?.erSelectedFusionScoreModifier || '',
    erFusionScoreModifier: quote?.erFusionScoreModifier || '',
    srPercentage: quote?.srPercentage || '',
    srModifier: quote?.srModifier || '',
    modifiedCoveragePremium: quote?.modifiedCoveragePremium || '',
  };
};
